import { render, staticRenderFns } from "./Storeabout.vue?vue&type=template&id=990a5bac&scoped=true&"
import script from "./Storeabout.vue?vue&type=script&lang=js&"
export * from "./Storeabout.vue?vue&type=script&lang=js&"
import style0 from "./Storeabout.vue?vue&type=style&index=0&id=990a5bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a5bac",
  null
  
)

export default component.exports